import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";
import {
    FL_DESCRIPTION,
    FL_INCLUDE,
    FL_NAME,
    FL_PRESENTATION,
    FL_SCHEDULE,
    FL_WARNING
} from "../../../components/i18n/formLabels";
import {
    PH_DESCRIPTION,
    PH_INCLUDE,
    PH_NAME,
    PH_PRESENTATION,
    PH_SCHEDULE,
    PH_WARNING
} from "../../../components/i18n/placeHolders";

const ActivityLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            name: '',
            description: '',
            included: '',
            warning: '',
            genreDetail: '',
            artist: '',
            sellingUrl: '',
            callToActionUrl:'',
            callToActionLabel:''
        }) )
        setLangChilds(items);
    }

    const formPark = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >Nombre</Label>
                    <Input type="name" name="name"
                           placeholder="Ingrese el nombre"
                           value= { child.name }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >Descripción</Label>
                    <Input type="textarea"
                           rows="10"
                           name="description"
                           placeholder="Ingrese descripción"
                           value={ child.description }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={ disableInputs }
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>Incluye</Label>
                    <Input type="textarea"
                           rows="10"
                           name="included"
                           placeholder="Incluye"
                           value={child.included}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label>Advertencias</Label>
                    <Input type="textarea"
                           rows="10"
                           name="warning"
                           placeholder="Ingrese advertencias"
                           value={child.warning}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label>{'Label del botón de acción'}</Label>
                    <Input type="text"
                           name="callToActionLabel"
                           placeholder="Etiqueta"
                           value={child.callToActionLabel}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label>{'URL del botón de acción'}</Label>
                    <Input type="text"
                           name="callToActionUrl"
                           placeholder="URL"
                           value={child.callToActionUrl}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    const formFerry = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_NAME }</Label>
                    <Input type="text"
                           name="name"
                           placeholder={ PH_NAME }
                           value={child.name}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_SCHEDULE }</Label>
                    <Input type="text"
                           name="schedule"
                           placeholder={ PH_SCHEDULE }
                           value={child.schedule}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_PRESENTATION }</Label>
                    <Input type="text"
                           name="presentation"
                           placeholder={ PH_PRESENTATION }
                           value={child.presentation}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea"
                           rows="3"
                           name="description"
                           placeholder={ PH_DESCRIPTION }
                           value={child.description}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_INCLUDE }</Label>
                    <Input type="textarea"
                           rows="10"
                           name="included"
                           placeholder={ PH_INCLUDE }
                           value={child.included}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >{ FL_WARNING }</Label>
                    <Input type="textarea" rows="10" name="warning"
                           placeholder={ PH_WARNING }
                           value={child.warning}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>d
    </>

    const formEvents = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >Nombre</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Ingrese el nombre"
                           value= { child.name }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >Descripción</Label>
                    <Input type="textarea"
                           rows="12"
                           name="description"
                           placeholder="Ingrese descripción"
                           value={child.description}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >URL de venta</Label>
                    <Input type="text"
                           name="sellingUrl"
                           placeholder="URL de venta"
                           value= { child.sellingUrl }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            {/*<Col md="6">*/}
            {/*    <FormGroup>*/}
            {/*        <Label >Detalles del genero</Label>*/}
            {/*        <Input type="name" name="genreDetail"*/}
            {/*               placeholder="Ingrese el detalle del genero"*/}
            {/*               value= { child.genreDetail }*/}
            {/*               onChange={e => onInputChange(e, child.lang)}*/}
            {/*               disabled={disableInputs}*/}
            {/*        />*/}
            {/*    </FormGroup>*/}
            {/*</Col>*/}
            {/*<Col md="6">*/}
            {/*    <FormGroup>*/}
            {/*        <Label >Artista</Label>*/}
            {/*        <Input type="name"*/}
            {/*               name="artist"*/}
            {/*               placeholder="Ingrese un artista"*/}
            {/*               value={child.artist}*/}
            {/*               onChange={e => onInputChange(e, child.lang)}*/}
            {/*               disabled={disableInputs}*/}
            {/*        />*/}
            {/*    </FormGroup>*/}
            {/*</Col>*/}
        </Row>
    </>


    const getFormulary = (child, index, disableInputs, onInputChange) => {
        switch (props.appCode) {
            case "PARK" :
                return formPark(child, index, disableInputs, onInputChange)
            case "FERRY" :
                return formFerry(child, index, disableInputs, onInputChange)
            case "EVENTS" :
                return formEvents(child, index, disableInputs, onInputChange)
            default:
                return formPark(child, index, disableInputs, onInputChange);
        }
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default ActivityLangs
